import { render, staticRenderFns } from "./resources-tab.vue?vue&type=template&id=200de13b"
import script from "./resources-tab.vue?vue&type=script&lang=js"
export * from "./resources-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports